import createImageUrlBuilder from '@sanity/image-url'
import { SanityImageSource } from '@sanity/image-url/lib/types/types'

import { dataset, projectId } from '../env'

// https://www.sanity.io/docs/image-url
const builder = createImageUrlBuilder({ projectId, dataset })

export const urlFor = (source: SanityImageSource) => {
  // Handle images that are still uploading or have _upload field
  if (source && typeof source === 'object' && '_upload' in source) {
    console.warn('Image is still uploading or not properly processed:', source)
    // Return a mock builder that returns empty strings
    return {
      url: () => '',
      width: (_w: number) => ({
        url: () => '',
        height: (_h: number) => ({ url: () => '' }),
      }),
      height: (_h: number) => ({
        url: () => '',
        width: (_w: number) => ({ url: () => '' }),
      }),
    }
  }

  // Handle null/undefined sources
  if (!source) {
    return {
      url: () => '',
      width: (_w: number) => ({
        url: () => '',
        height: (_h: number) => ({ url: () => '' }),
      }),
      height: (_h: number) => ({
        url: () => '',
        width: (_w: number) => ({ url: () => '' }),
      }),
    }
  }

  return builder.image(source)
}
